// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'en': 'en', 'ro': 'ro'},
        displayType: "language_code",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "0.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "FR",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Romania", "code": "RO", "currency": {"code": "RON", "symbol": "lei"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "Limba rom\u00e2n\u0103": {"name": "Limba rom\u00e2n\u0103 (Romanian)", "native_name": "Limba rom\u00e2n\u0103", "code": "ro", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        